// BOARD-RESULTS: the in-memory API's post results, posting times and findings. The demo
// companies run with the `board_results` flag off (the API's default), so a card's results read
// says `enabled: false` and every other route answers 404, as the real routes do.
import type { OperationOutput, RouteId } from "@companyos/sdk";
import { type Handler, json, notFound } from "./fake";

type Results = OperationOutput<"tasks.results.get">;

const off: Results = {
  enabled: false,
  publication: null,
  readings: { "24h": null, "72h": null },
  channels: [],
  formats: [],
};

export function createPostResultsHandlers(): Partial<Record<RouteId, Handler>> {
  return {
    "tasks.results.get": ({ principal }) => (principal ? json(off) : notFound()),
    "tasks.results.record": () => notFound(),
    "postingTimes.recommend": () => notFound(),
    "boards.findings": () => notFound(),
    "boards.researchSignals.setup": () => notFound(),
  };
}
